var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 17C19.1046 17 20 16.1046 20 15C20 14.6357 19.9026 14.2942 19.7324 14C19.3866 13.4022 18.7403 13 18 13C17.2597 13 16.6134 13.4022 16.2676 14C16.0974 14.2942 16 14.6357 16 15C16 16.1046 16.8954 17 18 17Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17C7.10457 17 8 16.1046 8 15C8 14.6357 7.90261 14.2942 7.73244 14C7.38663 13.4022 6.74028 13 6 13C5.25972 13 4.61337 13.4022 4.26756 14C4.09739 14.2942 4 14.6357 4 15C4 16.1046 4.89543 17 6 17Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13C22 13.4341 21.7234 13.8036 21.3368 13.9419C21.2596 13.6985 21.1566 13.4663 21.0308 13.2489C20.4279 12.2067 19.2974 11.5 18 11.5C16.7026 11.5 15.5721 12.2067 14.9692 13.2489C14.8334 13.4836 14.7242 13.7354 14.6454 14H9.35465C9.27583 13.7354 9.16658 13.4836 9.03084 13.2489C8.42794 12.2067 7.29738 11.5 6 11.5C4.70262 11.5 3.57206 12.2067 2.96916 13.2489C2.8434 13.4663 2.74037 13.6985 2.66322 13.9419C2.27663 13.8036 2 13.4341 2 13V10C2 9 3 9 3 9H7.72302C7.90426 9 8.0821 8.95074 8.23751 8.85749L12.7625 6.14251C12.9179 6.04926 13.0957 6 13.277 6H17.6667C17.883 6 18.0936 6.07018 18.2667 6.2L21.6 8.7C21.8518 8.88885 22 9.18524 22 9.5V13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarAlt1);
export default __webpack_public_path__ + "static/media/car-alt-1.53f9316f4ec94b988baa9c64d12112fd.svg";
export { ForwardRef as ReactComponent };